import { onDocumentLoaded, onResize } from "../../apps/StyleguideApp/helpers/utils"

function hideLeftColumnIfEmpty() {

  var leftSegments = document.getElementsByClassName('voyage__info-segment--left');
  if (leftSegments) {
    Array.from(leftSegments, function (leftSegment) {
      if (leftSegment.getElementsByTagName('*').length == 0) {
        leftSegment.style.display = getBrowserWidth() <= 739 ? 'none' : 'block';
      }
    });
  }
}

function getBrowserWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}

export default () => {
  onDocumentLoaded(hideLeftColumnIfEmpty);
  onResize(hideLeftColumnIfEmpty);
} 
